import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { ResultDocumentActionType } from '@models/document/actionsExecution/ICreateDocByTemplateModel';
import { FilesService } from '@services/FilesService';
import { sendNotification } from '@srm/ui/lib/notifications';
import { errorText, errorTraceId } from '@srm/core/errors';

export class CreateDocByTemplateExecutor extends DocBaseActionExecutor {
    runInternal = (
        objId: string,
        _parentId: string | undefined,
        action: IBaseAction,
        _rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
    ) => {
        const service = new DocumentExecutionService(objId);
        service
            .getCreateDocByTemplateModel(action.key)
            .then((res) => {
                if (res.data.result === ResultDocumentActionType.Download) {
                    // отказ скачивания FilesService показывает тостом с причиной сам
                    void FilesService.downloadFile(
                        `documentExecution/downloadTemplateDoc/${objId}/${action.key}`,
                    ).catch(() => undefined);
                    completeHandler && completeHandler(false);
                    return;
                }
                return service.createDocByTemplate(action.key).then(() => {
                    completeHandler && completeHandler(true);
                });
            })
            // без этого отказ оставлял действие незавершённым: остальные действия карточки не запускались
            .catch((error: unknown) => {
                sendNotification({
                    title: 'Не удалось создать документ по шаблону',
                    message: errorText(error),
                    traceId: errorTraceId(error),
                    variant: 'red',
                });
                completeHandler && completeHandler(false);
            });
    };
}
